export enum DisplayVariant {
  Variant1 = "VARIANT_1",
  Variant2 = "VARIANT_2",
}

export enum StatisticsFormat {
  None = "None",
  Comma = "COMMA",
  Dot = "DOT",
  Space = "SPACE",
}
